export default function Tab({ children, icon, iconClass, title }) {
  return <section>{children}</section>
}
